import React, { memo, useEffect, useMemo } from 'react'
import { Sparklines, SparklinesLine } from 'react-sparklines'

const SparklineCellRenderer = memo((params) => {
  const {value = null, valueFormatted, data = {}, colDef: {cellRendererParams}, context, api} = params;
  if (!value) return null;
  let lastValue = value[value.length - 1];

  const { decimal_places = null } = cellRendererParams?.original || {};
  if (decimal_places != null) {
    lastValue = Number(lastValue).toFixed(decimal_places);
  };

  const dotStyle = useMemo(() => {
    const { selection_options } = cellRendererParams?.original ?? {};

    const selection = selection_options?.reduce((currentMax, option) => {
      const isValid = option.value <= lastValue;
      const isGreater = !currentMax || option.value > currentMax.value;
      return isValid && isGreater ? option : currentMax;
    }, null);

    return selection ? {backgroundColor: selection.color} : null;
  }, [cellRendererParams, lastValue])

  const setContextQueryOption = (context, option, value) => {
    if (!value) {
      delete context.get_rows_params[option];
    } else {
      context.get_rows_params[option] = value;
    }
  }

  const displayEditActions = (show) => {
    if (show) {
      $('.datagrid-toolbar-component, .datagrid-statusbar-component').show();
    } else {
      $('.datagrid-toolbar-component, .datagrid-statusbar-component').hide();
    }
  }

  const viewRowHistory = () => {
    const editModeActive = $('.datagrid-edit-mode .sparkline-cell').length;
    if (editModeActive) return;

    let initialFilterModel = context.initial_filter_model;
    let newContext = {...context, get_rows_params: {...(context.get_rows_params || {})}};
    if (!initialFilterModel) {
      newContext.initial_filter_model = api.getFilterModel();
    }

    const viewHistory = !context.get_rows_params?.viewChangeHistory;
    const filterModel = viewHistory && data.row_id ? {row_id: {filterType: 'text', type: 'equals', filter: String(data.row_id)}} : (newContext.initial_filter_model || {});

    displayEditActions(!viewHistory);
    setContextQueryOption(newContext, 'filterModel', filterModel);
    setContextQueryOption(newContext, 'viewChangeHistory', viewHistory);

    api.setGridOption('context', newContext);
    api.setFilterModel(filterModel);
    api.refreshServerSide(/*{purge: true} */);
  }

  useEffect(() => {
    const model = api.getFilterModel();
    let newContext = {...context, get_rows_params: {...(context.get_rows_params || {})}};

    if (Object.keys((model || {})).length > 0 && newContext.get_rows_params.filterModel) {
      setContextQueryOption(newContext, 'filterModel', null)
      api.setGridOption('context', newContext);
    }
  }, [api.getFilterModel()])

  return (
    <div
      className={`sparkline-cell ${lastValue === 0 ? 'sparkline-zero-value' : ''}`}
      style={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%', maxWidth: 100 }}
      onClick={viewRowHistory}>
        <div style={{ flex: 1, height: '100%' }}>
          <Sparklines data={value} style={{height: '80%', width: '100%', marginTop: '8%'}}>
            <SparklinesLine color='lightgreen' style={{ strokeWidth: 5, fill: "none" }} />
          </Sparklines>
        </div>
        {dotStyle && <div className='sparkline-dot' style={dotStyle}></div>}
        <div style={{ marginLeft: 10 }}>{lastValue}</div>
    </div>
  )
})

export const validateSparklineCell = ({value, data, colDef, colDef: { cellRendererParams }}) => {
  if (!value) return true;
  return Array.isArray(value) && value.every((e) => typeof Number(e) === 'number');
}

export default SparklineCellRenderer;